import request from '@/utils/axios-request'
// 查询 controller-查询最新公司列表
export const apiLatestCompany = ():any => {
  return request({
    url: '/search/latest-company',
    method: 'get'
  })
}
